/**
 * CSV building for the registrations export.
 *
 * Every cell is attacker-controlled: name and city arrive from the public landing
 * page, which caps length but allows any character. So two separate concerns —
 * RFC 4180 field integrity, and Excel/Sheets treating some leading characters as the
 * start of a formula rather than as text.
 */

/** Leading characters a spreadsheet reads as a formula, not as text. */
const FORMULA_LEAD = /^[=+\-@\t\r]/;

/** Quoted per RFC 4180 so a comma cannot shift columns; `'` marks it as text, not a formula. */
export const csv_cell = (value) => {
  const text = String(value ?? '');
  const guarded = FORMULA_LEAD.test(text) ? `'${text}` : text;

  return `"${guarded.replace(/"/g, '""')}"`;
};

export const csv_of = (rows) => rows.map((row) => row.map(csv_cell).join(',')).join('\r\n');

export const download_csv = (filename, text) => {
  // Excel needs the BOM to read UTF-8, or an accented name arrives mangled.
  const url = URL.createObjectURL(new Blob([`\uFEFF${text}`], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
